import { format, parseISO, isValid } from "date-fns";

export default class Helpers {
    static formatDate(date: string | undefined, formatPattern = "dd'/'MM'/'yyyy' 'HH:mm:ss") {
        if (!date) {
            return "";
        }

        try {
            const parseDate = parseISO(date);
            if (!isValid(parseDate)) {
                return "";
            }

            return format(parseDate, formatPattern);
        } catch (error) {
            console.error("Invalid date passed to formatDate:", date);
            return "";
        }
    }
}
